import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Header from "components/Headers/Header";
import { Col, Container, Row, Spinner } from "reactstrap";
import { Link } from "react-router-dom";
import {
  getAdminEarnings,
  getRequiredPaypalAmount,
  getAthleteStats,
  getFanStats,
  getTotalIssues,
  getBoostEarnings,
} from "store/actions/dashboardAction";
import TabsInfoModal from "components/Modal/TabsInfoModal";
import { getAllUsers } from "store/actions/usersActions";
import { updateUserDeviceToken } from "store/actions/notificationAction";
import { messaging } from "config/firebase";

function Index() {
  let dispatch = useDispatch();
  let { user } = useSelector((state) => state.auth);

  const infoPoints = [
    "The admin reviews the platform's overall earnings generated through badges, chats, pizza money, GW, and registrations. This module also displays the total number of athletes and fans registered, those blocked by the admin, and any issues reported by athletes or fans.",
  ];
  const subPoints = [];
  const infoTitle = "Dashboard Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const [loader, setLoader] = useState({
    earnings: true,
    requiredAmount: true,
    athleteState: true,
    fanSate: true,
    issue: true,
    boostEarnings: true,
  });

  let {
    totalWalletAmount,
    adminEarnings,
    totalFans,
    totalAthletes,
    blockedFans,
    blockedAthletes,
    totalIssues,
    boostEarnings,
  } = useSelector((state) => state.dashboard);

  useEffect(() => {
    dispatch(
      getAdminEarnings(() => {
        setLoader((prev) => ({
          ...prev,
          earnings: false,
        }));
      })
    );
    dispatch(
      getRequiredPaypalAmount(() => {
        setLoader((prev) => ({
          ...prev,
          requiredAmount: false,
        }));
      })
    );
    dispatch(
      getAthleteStats(() => {
        setLoader((prev) => ({
          ...prev,
          athleteState: false,
        }));
      })
    );
    dispatch(
      getFanStats(() => {
        setLoader((prev) => ({
          ...prev,
          fanSate: false,
        }));
      })
    );
    dispatch(
      getTotalIssues(() => {
        setLoader((prev) => ({
          ...prev,
          issue: false,
        }));
      })
    );
    dispatch(
      getBoostEarnings(() => {
        setLoader((prev) => ({
          ...prev,
          boostEarnings: false,
        }));
      })
    );
  }, []);

  const createToken = async (user, dispatch) => {
    try {
      await navigator.serviceWorker.register("/firebase-messaging-sw.js");
      const registration = await navigator.serviceWorker.ready;
      const currentToken = await messaging.getToken({
        vapidKey:
          "BKtBn0Hxuy7MmztJf28DCm_M5M3sygGUP4F5QESuGUo4toV1fS2-Ex-h_8EWhXbO1ze3g9yiLDK-mo105WcNhIM",
        serviceWorkerRegistration: registration,
      });

      if (currentToken) {
        if (!user?.fcmToken || user.fcmToken !== currentToken) {
          dispatch(updateUserDeviceToken(currentToken, user.id));
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  const requestNotificationPermission = async (user, dispatch) => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        await createToken(user, dispatch);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!user) {
      dispatch(getAllUsers());
    }
    const initializeNotifications = async () => {
      if (!("Notification" in window) || !navigator.serviceWorker) {
        return;
      }
      if (Notification.permission === "granted") {
        await createToken(user, dispatch);
      } else if (Notification.permission === "default") {
        await requestNotificationPermission(user, dispatch);
      } else {
      }
    };

    initializeNotifications();
  }, [user, dispatch]);

  return (
    <>
      <Header />
      <Container className="mb-5" fluid>
        <Row>
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>
        <Row className="justify-content-center ">
          <Col md={12} lg={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers">
                {loader.requiredAmount ? (
                  <Spinner />
                ) : (
                  "$" + totalWalletAmount?.toFixed(2)
                )}
              </p>
              <p className="dashboard-card-title ">Required Paypal Amount</p>
            </div>
          </Col>
          <Col md={12} lg={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers">
                {loader.earnings || loader.boostEarnings ? (
                  <Spinner />
                ) : (
                  "$" + ((adminEarnings?.total_Earnings ?? 0) + (boostEarnings ?? 0)).toFixed(2)
                )}
              </p>
              <p className="dashboard-card-title">Total Earnings</p>
            </div>
          </Col>

          <Col md={12} lg={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers">
                {loader.earnings ? (
                  <Spinner />
                ) : (
                  "$" + (adminEarnings?.momento ?? 0).toFixed(2)
                )}
              </p>
              <p className="dashboard-card-title ">Earnings by Momentos</p>
            </div>
          </Col>
          <Col md={12} lg={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers">
                {loader.earnings ? (
                  <Spinner />
                ) : (
                  "$" + (adminEarnings?.school ?? 0).toFixed(2)
                )}
              </p>
              <p className="dashboard-card-title">Earnings by Schools</p>
            </div>
          </Col>
          <Col md={12} lg={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers">
                {loader.earnings ? (
                  <Spinner />
                ) : (
                  "$" +
                  (
                    (adminEarnings?.group_chat ?? 0) +
                    (adminEarnings?.single_chat ?? 0)
                  )?.toFixed(2)
                )}
              </p>
              <p className="dashboard-card-title">Earnings by chats</p>
            </div>
          </Col>
          <Col md={12} lg={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers">
                {loader.earnings ? (
                  <Spinner />
                ) : (
                  "$" + (adminEarnings?.sport_badge ?? 0).toFixed(2)
                )}
              </p>
              <p className="dashboard-card-title">Earnings by Sport Badges</p>
            </div>
          </Col>
          <Col md={12} lg={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers">
                {loader.earnings ? (
                  <Spinner />
                ) : (
                  "$" + (adminEarnings?.endorsement_badge ?? 0).toFixed(2)
                )}
              </p>
              <p className="dashboard-card-title">
                Earnings by Endorsement Badges
              </p>
            </div>
          </Col>
          <Col md={12} lg={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers">
                {loader.earnings ? (
                  <Spinner />
                ) : (
                  "$" + (adminEarnings?.seasonal_badge ?? 0).toFixed(2)
                )}
              </p>
              <p className="dashboard-card-title">
                Earnings by Seasonal Badges
              </p>
            </div>
          </Col>
          <Col md={12} lg={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers">
                {loader.earnings ? (
                  <Spinner />
                ) : (
                  "$" + (adminEarnings?.talking_badge ?? 0).toFixed(2)
                )}
              </p>
              <p className="dashboard-card-title">Earnings by Talking Badges</p>
            </div>
          </Col>
          <Col md={12} lg={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers">
                {loader.earnings ? (
                  <Spinner />
                ) : (
                  "$" + (adminEarnings?.vote_getter_badge ?? 0).toFixed(2)
                )}
              </p>
              <p className="dashboard-card-title">
                Earnings by Vote Getter Badges
              </p>
            </div>
          </Col>
          <Col md={12} lg={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers">
                {loader.earnings ? (
                  <Spinner />
                ) : (
                  "$" + (adminEarnings?.honor_badge ?? 0).toFixed(2)
                )}
              </p>
              <p className="dashboard-card-title">Earnings by Honor Badges</p>
            </div>
          </Col>
          <Col md={12} lg={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers">
                {loader.earnings ? (
                  <Spinner />
                ) : (
                  "$" + (adminEarnings?.pizza_money ?? 0).toFixed(2)
                )}
              </p>
              <p className="dashboard-card-title">Earnings by Pizza Money</p>
            </div>
          </Col>
          <Col md={12} lg={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers">
                {loader.earnings ? (
                  <Spinner />
                ) : (
                  "$" + (adminEarnings?.GW ?? 0).toFixed(2)
                )}
              </p>
              <p className="dashboard-card-title">Earnings by GW</p>
            </div>
          </Col>
          <Col md={12} lg={6} align="center">
            <div className="dashboard-card">
              <p className="dashboard-card-numbers">
                {loader.boostEarnings ? (
                  <Spinner />
                ) : (
                  "$" + (boostEarnings ?? 0).toFixed(2)
                )}
              </p>
              <p className="dashboard-card-title">Earnings by Boostings</p>
            </div>
          </Col>
          <Col md={12} lg={6} align="center">
            <Link to="/admin/players">
              <div className="dashboard-card">
                <p className="dashboard-card-numbers">
                  {loader.athleteState ? <Spinner /> : totalAthletes}
                </p>
                <p className="dashboard-card-title">Total Athletes </p>
              </div>
            </Link>
          </Col>
          <Col md={12} lg={6} align="center">
            <Link to="/admin/players">
              <div className="dashboard-card">
                <p className="dashboard-card-numbers">
                  {loader.athleteState ? <Spinner /> : blockedAthletes}
                </p>
                <p className="dashboard-card-title">Block Athletes </p>
              </div>
            </Link>
          </Col>
          <Col md={12} lg={6} align="center">
            <Link to="/admin/fans">
              <div className="dashboard-card">
                <p className="dashboard-card-numbers">
                  {loader.fanSate ? <Spinner /> : totalFans}
                </p>
                <p className="dashboard-card-title">Total Fans </p>
              </div>
            </Link>
          </Col>
          <Col md={12} lg={6} align="center">
            <Link to="/admin/users">
              <div className="dashboard-card">
                <p className="dashboard-card-numbers">
                  {loader.fanSate ? <Spinner /> : blockedFans}
                </p>
                <p className="dashboard-card-title">Block Fans</p>
              </div>
            </Link>
          </Col>
          <Col md={12} lg={6} align="center">
            <Link to="/admin/complaints">
              <div className="dashboard-card">
                <p className="dashboard-card-numbers">
                  {loader.issue ? <Spinner /> : totalIssues}
                </p>
                <p className="dashboard-card-title">Total Issues</p>
              </div>
            </Link>
          </Col>
        </Row>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
    </>
  );
}

export default Index;
